class CartDiscount extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.input = this.querySelector('input[name="discount"]');
    this.button = this.querySelector('button');
    this.error = this.querySelector('[data-discount-error]');

    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(event) {
    event.preventDefault();

    const code = this.input.value.trim();
    if (!code) {
      this.showError(this.dataset.emptyMessage);
      return;
    }

    this.setLoading(true);
    this.clearError();

    const cartDrawer = this.closest('cart-drawer');
    const sections = cartDrawer?.getSectionsToRender?.().map((section) => section.id) || [
      'cart-drawer',
      'cart-icon-bubble',
    ];
    const existingCodes = (this.dataset.codes || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
    const alreadyApplied = existingCodes.some((item) => item.toLowerCase() === code.toLowerCase());
    const discount = alreadyApplied ? existingCodes.join(',') : existingCodes.concat(code).join(',');

    fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({ discount, sections }),
    })
      .then((response) => response.json())
      .then((state) => {
        if (state.errors) {
          this.showError(typeof state.errors === 'string' ? state.errors : this.dataset.errorMessage);
          return;
        }

        const applyState = this.getApplyState(state, code);
        if (applyState === 'conflict') {
          this.showError(this.dataset.conflictMessage);
          return;
        }
        if (applyState !== 'applied') {
          this.showError(this.dataset.errorMessage);
          return;
        }

        if (cartDrawer && state.sections) {
          cartDrawer.renderContents(state);
          return;
        }

        this.refreshDrawer();
      })
      .catch(() => {
        this.showError(this.dataset.errorMessage);
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  getApplyState(cart, code) {
    const codes = cart.discount_codes || [];
    const matchedCode = codes.find((item) => item.code && item.code.toLowerCase() === code.toLowerCase());
    if (matchedCode) {
      return matchedCode.applicable === false ? 'conflict' : 'applied';
    }

    const applications = cart.cart_level_discount_applications || cart.discount_applications || [];
    const applied = applications.some((application) => {
      const title = application.title || application.code || '';
      return title.toLowerCase() === code.toLowerCase();
    });
    return applied ? 'applied' : 'invalid';
  }

  refreshDrawer() {
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceInner = html.querySelector('#CartDrawer');
        const targetInner = document.querySelector('#CartDrawer');
        if (sourceInner && targetInner) targetInner.innerHTML = sourceInner.innerHTML;
      });
  }

  decodeMessage(message) {
    const textarea = document.createElement('textarea');
    let decoded = String(message || '');
    for (let i = 0; i < 2; i++) {
      textarea.innerHTML = decoded;
      const next = textarea.value;
      if (next === decoded) break;
      decoded = next;
    }
    return decoded;
  }

  showError(message) {
    if (!this.error) return;
    this.error.textContent = this.decodeMessage(message);
    this.error.removeAttribute('hidden');
    this.input.setAttribute('aria-invalid', 'true');
  }

  clearError() {
    if (!this.error) return;
    this.error.textContent = '';
    this.error.setAttribute('hidden', '');
    this.input.removeAttribute('aria-invalid');
  }

  setLoading(isLoading) {
    this.button.disabled = isLoading;
    this.input.disabled = isLoading;
  }
}

if (!customElements.get('cart-discount')) {
  customElements.define('cart-discount', CartDiscount);
}
